@if (inited) {
  <app-crud-edit [form]="form" (save)="save()"></app-crud-edit>
}
